import { i18n } from "../i18n";
import { commonMenuItems } from "./common";
import defaultProfile from "./default";
import type { ConfigSection, GameProfile, Menu, ProfileCtx } from "./types";

const { t } = i18n.global;

const createMenu = (): Menu => {
  const menu = defaultProfile().menu;
  menu[0].items.push(commonMenuItems.logs);
  return menu;
};

const configSections: ConfigSection[] = [
  { component: "ConfSection", props: { name: "basic" } },
  { component: "TableSection", props: { name: "sessions", allowReorder: true } },
  { component: "ConfSection", props: { name: "weather" } },
  { component: "ConfSection", props: { name: "entry" } },
  { component: "ConfSection", props: { name: "race" } },
  { component: "ConfSection", props: { name: "pitstop" } },
];

const join = () => {
  window.open(t("ngp/settings/section/acc_pc_wiki/link"), "_blank", "noopener,noreferrer");
};

export default (_ctx: ProfileCtx): Partial<GameProfile> => ({
  menu: createMenu(),
  configSections,
  join: {
    buttonTextKey: "ngp/settings/section/acc_pc_wiki",
    joinFn: join,
  },
});
